import { Center, Spinner, SpinnerProps } from '@masterplandev/ui'

interface LoaderProps extends SpinnerProps {
  fixed?: boolean
}

const Loader = ({
  fixed = false,
  size = 'xl',
  ...spinnerProps
}: LoaderProps) => (
  <Center
    position={fixed ? 'fixed' : 'absolute'}
    inset={0}
    data-testid="loading-animation">
    <Spinner size={size} {...spinnerProps} />
  </Center>
)

export default Loader
